import DevStore from './store.dev';
import ProdStore from './store.prod';

export default (process.env.NODE_ENV === 'production') ? ProdStore : DevStore;



// WEBPACK FOOTER //
// ./usr/lib/ui/src/store/index.js